<script setup>
import { MoreHorizontal } from 'lucide-vue-next'
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

defineProps({
    title: {
        type: String,
        default: 'Options',
    },
    align: {
        type: String,
        default: 'end',
    },
})
</script>

<template>
    <DropdownMenu>
        <DropdownMenuTrigger as-child>
            <button
                class="export-ignore flex h-7 w-7 shrink-0 items-center justify-center rounded border border-slate-200 bg-white text-slate-700 transition-colors hover:border-slate-300 hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
                :title="title"
            >
                <slot name="icon">
                    <MoreHorizontal class="h-4 w-4" />
                </slot>
            </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent :align="align">
            <slot />
        </DropdownMenuContent>
    </DropdownMenu>
</template>
